<template>
	<div class="page">
		<div class="text-white text-center" style="font-size: 55px; padding-top: 70px;
		font-family: STXinwei; letter-spacing: 3px;">兰创校园管理系统</div>
		<div class="login_box" style="margin-top: 70px;">
			<!-- 头像区域 -->
			<div class="avatar_box">
				<img src="@/assets/images/logo.webp" class="rounded-circle" style="width: 100%; height: 100%;" />
			</div>
			<!-- 登录表单区域 -->
			<el-form style="position: absolute; bottom: 0; width: 100%; box-sizing: border-box;" class="px-2"
				ref="loginFormRef" :model="loginForm" :rules="loginFormRules">
				<!-- 账号 -->
				<el-form-item prop="account">
					<el-input v-model="loginForm.account" maxlength="16" prefix-icon="el-icon-user-solid"
					placeholder="请输入账号" clearable></el-input>
				</el-form-item>
				<!-- 密码 -->
				<el-form-item prop="password">
					<el-input type="password" v-model="loginForm.password" maxlength="16" prefix-icon="el-icon-s-goods"
					placeholder="请输入密码" clearable show-password></el-input>
				</el-form-item>
				<el-form-item prop="code">
					<el-input v-model="loginForm.code" style="width: 310px; float: left;" prefix-icon="el-icon-info" maxlength="5"
					placeholder="请输入验证码" clearable></el-input>
					<img class="captchaImg" :src="captcha" @click="getCaptcha"></img>
				</el-form-item>
				<!-- 按钮区域 -->
				<el-form-item class="d-flex j-end">
					<el-button type="primary" @click="login">登录</el-button>
					<el-button type="info" @click="resetLoginForm">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'login',
		data() {
			// 验证验证码的方法
			var checkCode = (rule, value, callback) => {
				if(value.length == 5) return callback()
				else callback(new Error('验证码长度为5个字符'))
			}
			return {
				captcha: null,
				captchaKey: null,
				// 这是登录表单的数据绑定对象
				loginForm: {
					account: null,
					password: null,
					code: null
				},
				
				// 这是表单的验证规则
				loginFormRules: {
					// 验证账号是否合法
					account: [
						{required: true,message: "请输入账号",trigger: "blur"},
						{max: 10, message: "账号长度不能超过10个字符",trigger: "blur"},
					],
					// 验证密码是否合法
					password: [
						{required: true,message: "请输入登录密码",trigger: "blur"},
						{min: 6,max: 15,message: "密码长度在 6 到 15 个字符",trigger: "blur"}
					],
					// 验证验证码格式是否合法
					code: [
						{required: true, message: "请输入验证码", trigger: "blur"},
						{ validator: checkCode, trigger: 'blur' }
					]
				},
			}
		},
		mounted() {
			this.getCaptcha()
			document.onkeydown = (e) => {
				if(e.keyCode == 13) this.login()  // 监听 'enter' 按键
			}
		},
		methods: {
			// 获取验证码
			async getCaptcha(){
				let {key, base64Img} = await this.$H.get('/admin/system/getCaptcha')
				this.captchaKey = key
				this.captcha = base64Img
			},
			// 点击重置按钮,重置登录表单
			resetLoginForm() {
				this.$refs.loginFormRef.resetFields()
			},
			// 点击登录按钮,校验表单信息是否合法
			login() {
				// 调用表单验证方法 validate() 验证表单是否合法 合法时返回 valid 参数为 true 不合法返回为 false 
				this.$refs.loginFormRef.validate(async (valid) => {
					// 如果 valid 为 false 则直接返回
					if (!valid) return
					let data = {
						account: this.loginForm.account,
						password: this.loginForm.password,
						code: this.loginForm.code,
						captchaKey: this.captchaKey
					}
					try{
						let res = await this.$H.post('/admin/fwUser/login', data)
						localStorage.setItem('token',res.token)
						this.$router.push('/index')
					}catch(e){
						this.getCaptcha()
					}
				})
			}
		}
	}
</script>

<style scoped>
	.page {
		height: 100%;
		width: 100%;
		background-image: url(../assets/images/loginBg0.jpg);
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.login_box {
		width: 480px;
		height: 340px;
		background-color: rgba(255, 255, 255, 0.3);
		border-radius: 3px;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.avatar_box {
		height: 130px;
		width: 130px;
		border: 1px solid #eee;
		border-radius: 50%;
		padding: 8px;
		box-shadow: 0 0 5px #ddd;
		position: absolute;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: rgba(255, 255, 255, 0.5);
	}
	.captchaImg {
      float: left;
      margin-left: 8px;
      border-radius: 4px;
	  height: 40px;
	  width: 120px;
   }
</style>
